/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.REACT_APP_SITECORE_API_KEY || "no-api-key-set",
config.sitecoreApiHost = process.env.REACT_APP_SITECORE_API_HOST || "",
config.jssAppName = process.env.REACT_APP_JSS_APP_NAME || "psn-website",
config.defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
config.graphQLEndpointPath = process.env.REACT_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/items/web",
config.graphQLEndpoint = process.env.REACT_APP_GRAPH_QL_ENDPOINT || `${config.graphQLEndpointPath}`;
module.exports = config;